class PeriodSelector {
    constructor(el) {
        this.el = el;

        if(this.el) {
            this.init();
        }
    }

    init() {
        this.topArea = this.el.querySelector('.amb-period-selector__top');
        this.slider = this.el.querySelector('.flickity-viewport');
        this.bottomArea = this.el.querySelector('.amb-period-selector__bottom');
        this.monthsNames = [...this.el.querySelectorAll('.amb-period-selector__month-name')];
        this.periods = [...this.el.querySelectorAll('.amb-period-selector__period')];

        this.currentMonthName = this.topArea.querySelector('.amb-period-selector__month-name--selected');
        this.currentPeriod = this.bottomArea.querySelector('.amb-period-selector__period--show');


        this.bindEvents();
    }

    bindEvents() {
        this.onMonthNameClickFn = this.onMonthNameClick.bind(this);
        
        for (let input of this.monthsNames) {
            input.addEventListener('click', (this.onMonthNameClickFn));
        }
    }

    onMonthNameClick(e) {
        const {target} = e;
        const index = this.monthsNames.indexOf(target);

        if(this.currentMonthName) {
            this.currentMonthName.classList.remove('amb-period-selector__month-name--selected');
        }
        if(this.currentPeriod) {
            this.currentPeriod.classList.remove('amb-period-selector__period--show');
        }

        target.classList.add('amb-period-selector__month-name--selected');
        
        this.currentMonthName = target;

        if(this.periods[index]) {
            this.currentPeriod = this.periods[index];
            this.periods[index].classList.add('amb-period-selector__period--show');
        }
        else {
            this.currentPeriod = null;
        }
    }
}

const initPeriodSelectors = function() {
    const periodSelectors = document.querySelectorAll('.amb-period-selector');
    
    if(periodSelectors.length) {
        for(periodSelector of periodSelectors) {
            new PeriodSelector(periodSelector);
        }
    }
};

if(document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', initPeriodSelectors);
}
else {
    initPeriodSelectors();   
}